export const languages = [
  { locale: 'en', imageUrl: '/assets/img/flags/en_US.png' },
  { locale: 'sv', imageUrl: '/assets/img/flags/sv_SE.png' }
];
